import { IconFacebook, IconInstagram } from "../ui/VisitIcons";

// The weekly dishes change every week and are posted on social media only.
function LunchOfferBanner({ t, instagramUrl, facebookUrl }) {
  return (
    <aside className="lunch-offer" aria-labelledby="lunch-offer-title">
      <div className="lunch-offer-stamp">
        <span className="lunch-offer-stamp-days">{t.days}</span>
        <span className="lunch-offer-stamp-time">{t.hours}</span>
        <span className="lunch-offer-stamp-note">{t.stampNote}</span>
      </div>

      <div className="lunch-offer-body">
        <p className="lunch-offer-eyebrow">{t.eyebrow}</p>
        <h3 id="lunch-offer-title" className="lunch-offer-title">
          {t.title}
        </h3>

        <ul className="lunch-offer-courses">
          {t.courses.map((course) => (
            <li key={course}>{course}</li>
          ))}
        </ul>

        <p className="lunch-offer-text">{t.text}</p>

        <div className="lunch-offer-links">
          <a
            className="lunch-offer-link lunch-offer-link--primary"
            href={instagramUrl}
            target="_blank"
            rel="noreferrer"
          >
            <IconInstagram className="lunch-offer-icon" />
            {t.instagram}
          </a>
          <a
            className="lunch-offer-link"
            href={facebookUrl}
            target="_blank"
            rel="noreferrer"
          >
            <IconFacebook className="lunch-offer-icon" />
            {t.facebook}
          </a>
        </div>
      </div>
    </aside>
  );
}

export default LunchOfferBanner;
